import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={s.loading}>Đang tải...</div>;
  if (!user)   return <Navigate to="/login" replace/>;
  return children;
}

export function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading)              return <div style={s.loading}>Đang tải...</div>;
  if (!user)                return <Navigate to="/login" replace/>;
  if (user.role !== 'admin')return <Navigate to="/" replace/>;
  return children;
}

const s = { loading: { textAlign:'center', padding:'60px', color:'#666' } };
